let requested = false;

export const requestDebugSnapshot = () => {
  requested = true;
};

export const takeDebugSnapshotRequest = () => {
  if (!requested) return false;
  requested = false;
  return true;
};

export const clearDebugSnapshotRequest = () => {
  requested = false;
};
